import { createFileRoute } from '@tanstack/react-router';
import { Playground } from '@/components/playground';
import { PageContent } from '@/components/page-content';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/playground',
)({
  component: PlaygroundSettings,
});

function PlaygroundSettings() {
  return (
    <PageContent>
      <Playground />
    </PageContent>
  );
}
